import { ErrorMessage, useFormik } from "formik";
import { AnimatePresence, motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { X } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import CantidadOfertasIcon from "../../assets/icons/CantidadOfertasIcon";
import ModuloEstadisticasIcon from "../../assets/icons/ModuloEstadisticasIcon";
import OfertasDestacadasIcon from "../../assets/icons/OfertasDestacadasIcon";
import RecibeOfertasIcon from "../../assets/icons/RecibeOfertasIcon";
import regionesComunas from "../../assets/RegionesComunas.json";
import { Alert } from "../../components/Alert";
import { AutocompletePlaces } from "../../components/AutocompletePlaces";
import { Button } from "../../components/Button";
import { FileSpace } from "../../components/FileSpace";
import { IconButton } from "../../components/IconButton";
import { MenuItem } from "../../components/MenuItem";
import { Modal } from "../../components/Modal";
import { Select } from "../../components/Select";
import { TextField } from "../../components/TextField";
import { FormState } from "../../models/form_state";
import { getAdvertising } from "../../redux/actions/advertising.action";
import { registerOfferer } from "../../redux/actions/auth.actions";
import { getCategories } from "../../redux/actions/categories.action";
import { AdvertisingState } from "../../redux/reducers/advertising.reducer";
import { AuthState } from "../../redux/reducers/auth.reducer";
import { CategoriesState } from "../../redux/reducers/categories.reducer";
import { RootState } from "../../redux/reducers/root.reducer";
import "yup-phone";
import '../../assets/css/plaintiffRegister.css';

export const OffererRegister = () => {
  const dispatch = useDispatch();
  const {
    offererRegister: { state: registerState, error: emailExists },
  } = useSelector<RootState, AuthState>((state) => state.authReducer);

  const [modal, setModal] = useState({
    open: false,
    text: "El archivo excede el tamaño maximo",
  });

  const openModal = (text: string) => {
    setModal({ open: true, text });
  };

  const handleCloseModal = () => {
    setModal({ open: false, text: "" });
  };
  useEffect(() => {
    dispatch(getCategories());
    // eslint-disable-next-line
  }, []);

  const { categories } = useSelector<RootState, CategoriesState>(
    (state) => state.categoriesReducer
  );
  const {
    handleSubmit,
    values,
    handleChange,
    touched,
    setFieldValue,
    errors,
    handleBlur,
  } = useFormik({
    initialValues: {
      Nombre: "",
      Apellido: "",
      Region: "",
      FechaNacimiento: "",
      Comuna: "",
      Email: "",
      Contrasena: "",
      RepetirContrasena: "",
      Direccion: "",
      Telefono: "",
      CategoriaServicios: "",
      Archivos: [] as File[],
      Premium: null,
      TerminosYCondiciones: null,
    },
    onSubmit: (values) => {
      dispatch(
        registerOfferer({
          ...values,
          Premium: Boolean(values.Premium),
          TerminosYCondiciones: Boolean(values.TerminosYCondiciones),
        })
      );
    },
    validationSchema: yup.object({
      Nombre: yup.string().required("Nombre  es Requerido"),
      Apellido: yup.string().required("Apellido es Requerido"),
      Region: yup.string().required("Region es Requerida"),
      Comuna: yup.string().required("Comuna es Requerida"),
      Contrasena: yup
        .string()
        .min(6, "Contrseña demasiado corta")
        .required("Contraseña requerida"),
      RepetirContrasena: yup
        .string()
        .max(255)
        .min(6, "Contrseña demasiado corta")
        .oneOf([yup.ref("Contrasena"), null], "Contraseñas no coinciden")
        .required("Contraseña Requerida"),
      CategoriaServicios: yup.string().required("La Categoria es requerida"),
      FechaNacimiento: yup
        .string()
        .required("Tu fecha de Nacimiento es Requerida"),
      Direccion: yup.string().required("Tu Dirección es Requerida"),
      Email: yup.string().email("Email no válido").required("Email requerido"),
      Telefono: yup
        .string()
        .matches(
          new RegExp("[0-9]{9}"),
          "Debe ingresar un numero en formato 912345678"
        )
        .required("Es requerido"),
      TerminosYCondiciones: yup
        .boolean()
        .nullable()
        .required("No ha aceptado los términos y condiciones"),
    }),
  });
  const handleChangeFiles = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.currentTarget.files;
    if (files && files.length > 0 && values.Archivos.length < 4) {
      const file = files.item(0)!;
      if (file?.size <= 10485760) {
        const newArray = [...values.Archivos];
        newArray.push(file);
        setFieldValue("Archivos", newArray);
      } else {
        // TODO: Debe saltar el dialogo
        openModal("El archivo excede el tamaño maximo");
      }
    } else {
      openModal("Se alcanzó la cantidad máxima de archivos");
    }
  };

  const handleDeleteFile = (index: number) => {
    const finded = values.Archivos[index];
    if (!finded) {
      return;
    }
    const newArray = values.Archivos.filter((item: any) => item !== finded);
    setFieldValue("Archivos", newArray, false);
  };

  const [open, setOpen] = useState(false);

  const handleOnClose = () => {
    setOpen(false);
  };


  const handleShowTerms = () => {};

  const [actualWidth, setActualWidth] = useState(window.innerWidth);

  const resizeHandler = () => {
    const width = window.innerWidth;

    setActualWidth(width);
  };

  useEffect(() => {
    window.addEventListener("resize", resizeHandler);
  }, []);

  useEffect(() => {
    dispatch(getAdvertising());
  }, []);

  const { state: advertisingState, advertisings } = useSelector<
    RootState,
    AdvertisingState
  >((state) => state.advertisingReducer);
  const AdvertisingSup = advertisings.filter(
    (x) => x.Vista === "Registro" && x.Posicion === "superior"
  );
  const AdvertisingBot = advertisings.filter(
    (x) => x.Vista === "Registro" && x.Posicion === "inferior"
  );

  return (
    <React.Fragment>
      <div className="bg-no-repeat bf-color-softBlue bg-contain w-full z-10 shadow-md banner-register-offer">
      </div>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="container mx-auto mt-5"
      >
        <div>
          <h1 className=" text-3xl font-bold text-deepBlue ml-5">
            Registro Oferentes
          </h1>
        </div>
        {AdvertisingSup.length === 1 && (
          <a href={AdvertisingSup[0].Link} target={"_blank"}>
            {actualWidth > 400 ? (
              <img
                src={AdvertisingSup[0].Imagen.URL}
                className="mx-auto rounded-md mt-10 object-cover"
                style={{ width: 1309, height: 150 }}
              ></img>
            ) : (
              <img
                src={AdvertisingSup[0].ImagenMovil.URL}
                className="mx-auto rounded-md mt-7 object-cover "
                style={{ width: 1309, height: 150 }}
              ></img>
            )}
          </a>
        )}
        <form onSubmit={handleSubmit} className="my-10">
          {touched.TerminosYCondiciones && errors.TerminosYCondiciones && (
            <AnimatePresence
              initial={false}
              exitBeforeEnter={true}
              onExitComplete={() => null}
            >
              <Alert severity="error" className="my-5">
                {"Debes aceptar los términos y condiciones"}
              </Alert>
            </AnimatePresence>
          )}
          <div className="grid grid-cols-1 mx-5 sm:grid-cols-2 gap-3 justify-between px-6 md:px-0">
            <TextField
              label="Nombre"
              placeholder="Ingresa tu Nombre"
              id="Nombre"
              value={values.Nombre}
              onChange={handleChange}
              helperText={touched.Nombre && errors.Nombre}
              error={touched.Nombre && Boolean(errors.Nombre)}
              required
            />
            <TextField
              label="Apellido"
              placeholder="Ingresa tu Apellido"
              id="Apellido"
              value={values.Apellido}
              onChange={handleChange}
              helperText={touched.Apellido && errors.Apellido}
              error={touched.Apellido && Boolean(errors.Apellido)}
              required
            />
            <TextField
              label="Fecha De Nacimiento"
              placeholder="Ingresa tu Fecha de Nacimiento"
              id="FechaNacimiento"
              type="date"
              value={values.FechaNacimiento}
              onChange={handleChange}
              helperText={touched.FechaNacimiento && errors.FechaNacimiento}
              error={touched.FechaNacimiento && Boolean(errors.FechaNacimiento)}
              required
            />

            <TextField
              id="Telefono"
              label="Teléfono"
              placeholder="Ingresa tu Numero de teléfono"
              value={values.Telefono}
              onChange={handleChange}
              /* pattern="[9][0-9]{8}"   */
              maxLength={9}
              helperText={touched.Telefono && errors.Telefono}
              error={touched.Telefono && Boolean(errors.Telefono)}
              onBlur={handleBlur}
              required
            />

            <AutocompletePlaces
              helperText={touched.Direccion && errors.Direccion}
              error={touched.Direccion && Boolean(errors.Direccion)}
              label="Dirección"
              id="Direccion"
              disabled={false}
              onChange={(place) => {
                if (place) {
                  const address = place.formatted_address;
                  const placeId = place.place_id;
                  const location = {
                    lat: place.geometry?.location?.lat(),
                    lng: place.geometry?.location?.lng(),
                  };
                  let region = "";
                  let city = "";

                  place.address_components?.forEach((component) => {
                    // Region
                    if (
                      component.types.includes("administrative_area_level_1")
                    ) {
                      region = component.long_name;
                    }
                    // Ciudad
                    if (
                      component.types.includes("administrative_area_level_3")
                    ) {
                      city = component.long_name;
                    }
                  });

                  const findedRegion = regionesComunas.regiones.find((r) =>
                    r.region
                      .toLocaleLowerCase()
                      .match(region.toLocaleLowerCase())
                  );
                  const findedCity = findedRegion?.comunas.find((c) =>
                    c.toLocaleLowerCase().match(city.toLocaleLowerCase())
                  );

                  setFieldValue("Direccion", address, false);
                  setFieldValue("Ubicacion", location, false);
                  setFieldValue("PlaceId", placeId, false);
                  setFieldValue("Region", findedRegion?.region, false);
                  setTimeout(() => {
                    setFieldValue("Comuna", findedCity, false);
                  }, 100);
                }
              }}
            />
            <Select
              helperText={touched.Region && errors.Region}
              error={touched.Region && Boolean(errors.Region)}
              id="Region"
              fullWidth
              label="Región"
              placeholder="Seleccionar Región"
              value={values.Region}
              onChange={(value) => {
                setFieldValue("Region", value);
                setFieldValue("Comuna", "");
              }}
            >
              {regionesComunas.regiones.map((region, index) => {
                return (
                  <MenuItem
                    key={`region-${index}`}
                    value={region.region}
                    label={region.region}
                  />
                );
              })}
            </Select>

            {/* TODO: hacer warning de seleccionar region primero */}
            <Select
              helperText={touched.Comuna && errors.Comuna}
              error={touched.Comuna && Boolean(errors.Comuna)}
              id="Comuna"
              fullWidth
              label="Comuna"
              placeholder="Seleccionar Comuna"
              value={values.Comuna}
              onChange={(value) => {
                setFieldValue("Comuna", value);
              }}
            >
              {values.Region &&
                regionesComunas.regiones
                  .find((x) => x.region === values.Region)
                  ?.comunas?.map((comuna, index) => (
                    <MenuItem
                      key={`comuna-${index}`}
                      value={comuna}
                      label={comuna}
                    />
                  ))}
            </Select>
            <div>
              <TextField
                label="Email"
                placeholder="Ingresa tu Email"
                id="Email"
                value={values.Email}
                onChange={handleChange}
                helperText={touched.Email && errors.Email}
                error={touched.Email && Boolean(errors.Email)}
                required
              />
              {emailExists !== undefined && (
                <span className="text-red-500 font-semibold text-left ml-3">
                  Este correo electrónico ya está registrado
                </span>
              )}
            </div>

            <TextField
              label="Contraseña"
              placeholder="Ingresa tu Contraseña"
              id="Contrasena"
              type="password"
              value={values.Contrasena}
              onChange={handleChange}
              helperText={touched.Contrasena && errors.Contrasena}
              error={touched.Contrasena && Boolean(errors.Contrasena)}
            />
            <TextField
              label="Repetir Contraseña"
              placeholder="Repetir Contraseña"
              id="RepetirContrasena"
              type="password"
              value={values.RepetirContrasena}
              onChange={handleChange}
              helperText={touched.RepetirContrasena && errors.RepetirContrasena}
              error={
                touched.RepetirContrasena && Boolean(errors.RepetirContrasena)
              }
            />
            <div className="flex flex-col">
              <Select
                id="CategoriaServicios"
                fullWidth
                label="Categoría"
                placeholder="Seleccionar Categoría"
                value={values.CategoriaServicios}
                helperText={
                  touched.CategoriaServicios && errors.CategoriaServicios
                }
                error={
                  touched.CategoriaServicios &&
                  Boolean(errors.CategoriaServicios)
                }
                onChange={(value) => {
                  setFieldValue("CategoriaServicios", value);
                }}
              >
                {categories.map((category, index) => {
                  return (
                    <MenuItem
                      value={category.Nombre}
                      label={category.Nombre}
                      key={`category-${index}`}
                    />
                  );
                })}
              </Select>
            </div>
            <div className="flex flex-col pb-10">
              <TextField
                label="Adjuntar Certificaciones"
                type="file"
                accept=".png, .jpg, .jpeg,.pdf,.doc,.docx"
                onChange={handleChangeFiles}
              />
              <p className="text-gray-400 mt-2 mb-2">
                *Máximo 4 documentos hasta 10 MB por cada uno.
              </p>
              <div className="flex">
                <FileSpace
                  disabled={false}
                  files={values.Archivos}
                  handleDeleteFile={handleDeleteFile}
                />
              </div>
              <div>
                {/* <h6 className="text-deepBlue mt-8 font-bold mb-4">
                  Suscripción Premium
                </h6> */}

                {/*TODO: Esto deberia ser un dato de la base de datos */}
                {/* <label className="flex items-center " htmlFor="">
                  <input
                    id="Premium"
                    checked={Boolean(values.Premium)}
                    className="h-5 w-5 mr-3 "
                    type="checkbox"
                    onChange={(event) =>
                      setFieldValue("Premium", !values.Premium)
                    }
                  />
                  <p className="text-gray-400 font-semibold flex-1">
                    Quiero ser Premium
                    <span
                      className="text-primary cursor-pointer"
                      onClick={handleShowDetails}
                    >
                      &nbsp;($30.000 por 3 meses - Ver detalle)
                    </span>
                  </p>
                </label> */}
                <label className="flex items-center " htmlFor="">
                  <input
                    id="TerminosYCondiciones"
                    className="h-5 w-5 mr-3 "
                    type="checkbox"
                    checked={Boolean(values.TerminosYCondiciones)}
                    onChange={(event) =>
                      setFieldValue(
                        "TerminosYCondiciones",
                        !values.TerminosYCondiciones
                      )
                    }
                  />
                  <p className="text-gray-400 font-semibold flex-1">
                    Acepto los
                    <a
                      target={"_blank"}
                      href={
                        "https://firebasestorage.googleapis.com/v0/b/demandapp-4cc44.appspot.com/o/TerminosYCondiciones%2FT%C3%A9rminos_y_Condiciones.pdf?alt=media&token=1b4288ff-a523-4b12-9270-ea40c0a19d33"
                      }
                    >
                      <span
                        className="text-primary cursor-pointer"
                        onClick={handleShowTerms}
                      >
                        &nbsp;Términos y Condiciones
                      </span>
                    </a>
                  </p>
                </label>
                <Button
                  type="submit"
                  text="Registrarse"
                  color="secondary"
                  fullWidth
                  className="mt-10"
                  disabled={registerState === FormState.Submitting}
                  isLoading={registerState === FormState.Submitting}
                />
              </div>
            </div>
          </div>
        </form>
        {AdvertisingBot.length === 1 && (
          <a href={AdvertisingBot[0].Link} target={"_blank"}>
            {actualWidth > 400 ? (
              <img
                src={AdvertisingBot[0].Imagen.URL}
                className="mx-auto rounded-md mb-5 object-cover"
                style={{ width: 1309, height: 150 }}
              ></img>
            ) : (
              <img
                src={AdvertisingBot[0].ImagenMovil.URL}
                className="mx-auto rounded-md mb-5 object-cover"
                style={{ width: 1309, height: 150 }}
              ></img>
            )}{" "}
          </a>
        )}
      </motion.div>
      <Modal isVisible={open} onClose={handleOnClose} isDismiseble>
        <PremiumInfo onClose={handleOnClose} />
      </Modal>
      <Modal isVisible={modal.open} onClose={handleCloseModal}>
        <div className="bg-white w-full rounded-lg text-center p-4">
          <p className="text-sm font-semibold">{modal.text}</p>
          <Button
            text={"Ok"}
            className="mt-3 bg-primary-light text-white font-semibold"
            paddingClassname="py-1 px-3"
            onClick={handleCloseModal}
          />
        </div>
      </Modal>
    </React.Fragment>
  );
};

const PremiumInfo = ({ onClose }: any) => {
  const info = [
    { title: "Módulo de estadísticas", Icon: ModuloEstadisticasIcon },
    { title: "Módulo de alertas \npersonalizadas", Icon: RecibeOfertasIcon },
    {
      title: "Cantidad de ofertas de una \ndemanda",
      Icon: CantidadOfertasIcon,
    },
    { title: "Ofertas destacadas", Icon: OfertasDestacadasIcon },
  ];

  return (
    <div className="bg-white shadow-lg w-full px-8 pb-8 pt-4 rounded-lg">
      <div className="flex flex-row-reverse">
        <IconButton onClick={onClose}>
          <X size={32} className="text-secondary" />
        </IconButton>
      </div>
      <div className="px-4 flex flex-col items-center">
        <h1 className="text-2xl font-bold text-secondary">
          ¿Que es la Membresía Premium?
        </h1>
        <h4 className="text-lg font-bold text-primary">
          Por un Monto de $56.000 por 3 meses podras acceder a:
        </h4>
        <div className="grid grid-cols-2 gap-3 mt-5">
          {info.map((item, index) => {
            return (
              <div
                key={`info-item-${index}`}
                className="bg-primary bg-opacity-20 rounded-lg flex flex-col justify-center items-center text-secondary h-40 px-5"
              >
                {item.Icon && <item.Icon height={64} width={64} />}
                <span className="text-sm font-bold text-center">
                  {item.title}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
